import styled from 'styled-components';

// COLORS
import { RADICAL_RED, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;
  display: flex;
  padding: 16px 40px 16px 16px;
  border-radius: 8px;
  overflow: hidden;

  ${breakpoints.down('sm')} {
    padding: 16px;
  }

  .banner-app {
    &__left-cont,
    &__right-cont {
      display: flex;
      align-items: center;
    }

    &__left-cont {
      ${breakpoints.down('xs')} {
        align-items: flex-start;
      }
    }

    &__right-cont {
      justify-content: space-between;

      ${breakpoints.down('xs')} {
        flex-direction: column;
      }
    }

    &__link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    &__logo {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 140px;
      width: 170px;
      border-radius: 12px;
      padding: 10px;
      background-color: ${WHITE};
      margin-right: 15px;

      ${breakpoints.down('xs')} {
        height: 105px;
        width: 128px;
      }

      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
      }
    }

    &__trial {
      font-size: 1.4rem;
      line-height: 1.4rem;
      font-weight: 600;
      margin-bottom: 5px;
    }

    &__desc {
      margin-right: 30px;

      p {
        margin-bottom: 0;
      }

      ${breakpoints.down('xs')} {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }

    &__name {
      line-height: 3.8rem;
    }

    &__btn {
      position: relative;
      z-index: 2;
      min-width: 215px;

      ${breakpoints.down('xs')} {
        width: 100%;
      }
    }
  }
`;

export const Price = styled.div`
  line-height: 2rem;

  ${breakpoints.down('xs')} {
    line-height: 1.6rem;
  }

  .price {
    &__price {
      ${breakpoints.down('xs')} {
        font-size: 1.6rem;
        line-height: 1.6rem;
      }
    }

    &__old {
      position: relative;
      display: inline-block;

      &:before {
        content: '';
        position: absolute;
        right: -3px;
        left: -3px;
        top: 50%;
        transform: translate(0, -50%);
        height: 1px;
        background-color: ${RADICAL_RED};
      }
    }
  }
`;

export default Container;
